export const workerShortlistNotesQuery = `
    query worker_shortlist_notes (
        $worker_id: String!,
    ) {
        worker_shortlist_notes (
            worker_id: $worker_id
        ) {
            shortlist {
                job_position {
                    assigned_to_user {
                        user_id,
                        icon_url,
                        name
                    },
                    restaurant {
                        restaurant_name
                    },
                    occupation {
                        label_it {
                            label
                        }
                    }
                },
                job_position_id
            },
            notes,
            shortlist_id,
            worker_id,
            inserted_at
        }
    }
`;

export const indexEmployerJobApplicationsQuery = `
  query index_employer_job_applications (
    $limit: Int!,
    $offset: Int!,
    $employer_id: String,
    $organization_id: String,
    $search_vector: String,
    $spontaneous_applications: Boolean
  ) {
    index_employer_job_applications (
      limit: $limit,
      offset: $offset,
      employer_id: $employer_id,
      organization_id: $organization_id,
      search_vector: $search_vector
      spontaneous_applications: $spontaneous_applications
    ) {
      hits
      data {
        worker_distance
        shortlist_inserted_at
        job_application {
          id
          worker {
            user_id
            name
            surname
            birthdate
            cv
            user {
              email
              phone_number
            }
            transportation_options {
              transportation_var {
                key
                label
              }
            }
            professional_associations {
              professional_association_var {
                id
                key
                label
                description
                icon
              }
            }
            main_picture
            worker_shortlist_notes {
              shortlist_id
              shortlist {
                job_position_id
              }
              worker_id
              notes
              inserted_at
              updated_at
            }
          }
          job_position_id
          job_position {
            id
            occupation {
              id
              label_it {
                label
              }
            }
            restaurant {
              id
              restaurant_name
              address
            }
          }
          restaurant_id
          restaurant {
            id
            restaurant_name
            address
          }
          status_key
          status {
            key
            label
            sentiment
          }
        }
        worker_shortlist_note
        shortlist_id
      }
    }
  }
`;

export const indexJobApplicationsEmployerJPPageQuery = `
  query index_job_applications (
    $limit: Int,
    $offset: Int,
    $job_position_id: String,
    $status_key: [String],
    $show_worker_distance: Boolean,
    $spontaneous_applications: Boolean,
    $search_vector: String,
    $hidden: Boolean,
    $restaurant_id: String,
    $association_status: String,
  ) {
    index_job_applications (
      limit: $limit,
      offset: $offset,
      job_position_id: $job_position_id,
      status_key: $status_key,
      show_worker_distance: $show_worker_distance,
      spontaneous_applications: $spontaneous_applications,
      search_vector: $search_vector,
      hidden: $hidden,
      restaurant_id: $restaurant_id,
      association_status: $association_status
    ) {
      hits
      data {
        id
        job_position_id
        cover_letter
        hidden
        interview_date
        last_bench_status_change_timestamp
        last_status_change_date
        has_finished_assessment
        scheduled_hiring_date
        inserted_at
        worker_distance_to_restaurant
        stage_start_date
        stage_end_date
        restaurant_id
        recommended
        added_to_shortlist_at
        discarded_reason_var {
          id
          key
          label
        }
        discarded_other_reason
        restaurant {
          id
          restaurant_name
          address
          restaurant_logo
        }
        status_key
        status {
          id
          key
          label
        }
        discarded_at
        discarded_automatically
        discarded_by
        discarded_from_status_key
        discarded_from_status {
          id
          key
          label
        }
        worker_presentation {
          id
          presentation
          candidate_highlights
          last_modified_by_rw_member {
            name
            surname
            user_id
            user {
              id
              email
              name
              surname
            }
          }
        }
        evaluation {
          evaluation_analysis
          score
          alerts {
            relocation
            instability
            overqualified
            salary_mismatch
            availability_risk
            motivation_unclear
            misaligned_background
            preassessment_missing
          }
          highlights
          unsuitability_reason
          suggested_interview_questions
          distance_constraint_failed
          preassessment_not_completed
          job_offer_corpus_markdown
          match_breakdown {
            job_offer_anchor
            criterion
            job_offer_fragment
            candidate_profile_fragment
            match_quality
          }
          inserted_at
          updated_at
        }
        worker_id
        worker {
          address
          name
          surname
          cv
          show_document_cv
          main_picture
          professional_associations {
            professional_association_var {
              id
              key
              label
              description
              icon
            }
          }
          birthdate
          presentation
          motivation_text
          worker_references {
            id
            referent_name
            referent_surname
            message
            workplace_relationship
            inserted_at
            worker_past_experience {
              id
              restaurant_name
              from_date
              to_date
            }
          }
          job_types {
            job_type_var {
              id
              key
              label
            }
          }
          shifts {
            shift_var {
              id
              key
              label
            }
          }
          research_info {
            domain_interest
            domain_interest_var {
              id
              key
              label
            }
            restaurant_types {
              restaurant_type_var {
                id
                key
                label
              }
            }
            occupations {
              id
              label_it {
                label
              }
            }
          }
          certificates {
            certificate_type_var {
              id
              key
              label
            }
            corporate_name
            course_name
            date
          }
          education_em {
            education_title_var {
              id
              key
              label
            }
            issue_date
          }
          languages {
            language_var {
              id
              key
              label
            }
            language_level_cefr_var {
              id
              key
              label
            }
          }
          past_experiences {
            id
            restaurant_name
            description
            from_date
            to_date
            skills {
              id
              label_it {
                label
              }
            }
            domain_interest_var {
              id
              key
              label
            }
            occupation {
              id
              label_it {
                id
                label
              }
            }
          }
          communication_channel_preferences {
            communication_channel_var {
              id
              key
              label
            }
          }
          driving_licenses {
            driving_license_var {
              id
              key
              label
            }
          }
          transportation_options {
            transportation_var {
              id
              key
              label
            }
          }
          displacement_availability_var {
            id
            key
            label
          }
          displacement_preferences {
            displacement_preference_var {
              id
              key
              label
            }
          }
          sex
          sex_var {
            id
            key
            label
          }
          user_id
          user {
            id
            email
            phone_number
            name
            surname
          }
        }
      }
    }
  }
`;

export const indexJobApplicationsLABQuery = `
  query index_job_applications (
    $limit: Int,
    $offset: Int,
    $order_by: [String],
    $job_position_id: String,
    $association_status: String,
    $status_key: [String],
    $show_worker_distance: Boolean,
    $spontaneous_applications: Boolean,
    $search_vector: String,
    $hidden: Boolean,
    $restaurant_id: String,
    $discarded_by: [String],
    $reinstated_from_rejected_status: Boolean,
    $is_contacted: Boolean,
    $sex: [String],
    $age_from: Int,
    $age_to: Int,
    $max_restaurant_distance: String,
    $transportation_options: [String],
    $experience: [String],
    $domain_interest: [String],
    $occupations: [String],
    $languages: [String],
    $skills: [String],
    $displacement_availability: [String],
    $displacement_preferences: [String],
    $job_type: [String],
    $added_to_shortlist_by: [String],
    $recommended: Boolean
  ) {
    index_job_applications (
      limit: $limit,
      offset: $offset,
      order_by: $order_by,
      job_position_id: $job_position_id,
      association_status: $association_status,
      status_key: $status_key,
      show_worker_distance: $show_worker_distance,
      spontaneous_applications: $spontaneous_applications,
      search_vector: $search_vector,
      hidden: $hidden,
      restaurant_id: $restaurant_id,
      discarded_by: $discarded_by,
      reinstated_from_rejected_status: $reinstated_from_rejected_status,
      is_contacted: $is_contacted,
      sex: $sex,
      age_from: $age_from,
      age_to: $age_to,
      max_restaurant_distance: $max_restaurant_distance,
      transportation_options: $transportation_options,
      experience: $experience,
      domain_interest: $domain_interest,
      occupations: $occupations,
      languages: $languages,
      skills: $skills,
      displacement_availability: $displacement_availability,
      displacement_preferences: $displacement_preferences,
      job_type: $job_type,
      added_to_shortlist_by: $added_to_shortlist_by,
      recommended: $recommended
    ) {
      hits
      data {
              id
              pinned
              added_to_shortlist_by
              added_to_shortlist_at
              status_key
              custom_discard_motivation
              discarded_at
              discarded_by
              discarded_reason
              discarded_other_reason
              discarded_reason_var {
                  id
                  label
              }
              source
              ambassador_code
              inserted_at
              updated_at
              worker_distance_to_restaurant
              last_status_change_date
              recommended
              job_position_id
              status {
                  id
                  key
                  label
                  sentiment
              }
              conversation_steps {
                  id
                  closed_at
                  status
                  owner {
                    user_id
                    roles {
                      id
                      key
                    }
                  }
                  category_var {
                    id
                    label
                    key
                  }
              }
              complaint {
                  id
                  message
                  inserted_at
                  updated_at
                  finalized
                  finalized_at
              }
              evaluation {
                  id
                  job_application_id
                  evaluation_analysis
                  score
                  alerts {
                      relocation
                      instability
                      overqualified
                      salary_mismatch
                      availability_risk
                      motivation_unclear
                      misaligned_background
                      preassessment_missing
                  }
                  highlights
                  unsuitability_reason
                  suggested_interview_questions
                  distance_constraint_failed
                  preassessment_not_completed
                  job_offer_corpus_markdown
                  match_breakdown {
                      job_offer_anchor
                      criterion
                      job_offer_fragment
                      candidate_profile_fragment
                      match_quality
                  }
                  inserted_at
                  updated_at
              }
              klaaryo_conversation {
                  job_application_id
                  klaaryo_campaign_id
                  klaaryo_thread_id
                  klaaryo_conversation_id
                  conversation_status
                  new_assessment_agent
              }
              worker_id
              worker {
                  name
                  surname
                  user_id
                  birthdate
                  cv
                  research_status {
                    id
                    label
                    key
                  }
                  research_status_last_updated
                  assets {
                      type
                      url
                  }
                  research_info {
                      foreground
                      occupations {
                          label_it {
                              label
                          }
                      }
                      domain_interest_var {
                          label
                      }
                  }
                  transportation_options {
                      transportation_var {
                          id
                          key
                          label
                      }
                  }
                  past_experiences {
                      occupation {
                          label_it {
                              label
                          }
                      },
                      from_date,
                      to_date,
                      restaurant_name,
                      restaurant_type_var {
                          label
                      },
                      city,
                      description,
                      skills {
                          id,
                          label_it {
                              label
                          }
                      }
                      references {
                          id,
                          worker_past_experience_id,
                          referent_name,
                          referent_surname,
                          message,
                          workplace_relationship,
                          visible_to_employers,
                          made_visible_to_employer_at,
                          ex_employers_email,
                          inserted_at,
                          updated_at
                      },
                      inconsistencies {
                          id,
                          worker_past_experience_id,
                          message,
                          inserted_at,
                          updated_at
                      }
                  }
                  worker_reports {
                      id
                  }
                  notes {
                      id
                  }
                  worker_shortlist_notes {
                      worker_id
                      shortlist_id
                  }
                  user {
                      id
                      name
                      surname
                      last_login
                      email
                      phone_number
                  }
              }
          }
      }
  }
`;
